<template>
	<db-col class="upload-wrapper" height="auto" wrap width="auto">
		<db-col v-if="!simple" width="auto" height="auto">
			<db-col valign="middle" @click="zoom(img)" align="center" width="120" height="120" class="box-border ovh" v-for="(img, idx) in temps" :key="idx" v-if="img.show">
				<db-col v-show="!preview" width="320" height="320" class="upload-init" :class="img.status == 'loading' ? 'upload-loading' : ''"></db-col>
				<db-lazy :lazy="false" width="100%" height="100%" class="upload-pic" :src="img.src" v-if="img.show" @handler="showImage(img)" />
				<db-icon @click="remove(img)" width="40" size="12" height="40" color="#FFFFFF" class="icon-close" icon="close" v-if="img.status !== 'init' || preview" />
				<db-icon icon="loading" v-if="img.status == 'init' && !preview" class="animation-circle" color="#FFFFFF" />
			</db-col>
		</db-col>
		
		<db-icon class="box-border photo" size="50" color="inherit" icon="camera" width="120" height="120" @click="appClick">
			<input type="file" id="uploader" :accept="accept" @change="changeHandler" multiple class="photo-input" />
		</db-icon>
	</db-col>
</template>

<script>
	import {CaptureTypes, UploadAccepts} from '../../../../enum'
	import UploadEntity from '../../../../model/UploadEntity'
	
	export default {
		name: 'upload',
		
		props: {
			capture: {
				type: String,
				default: ''
			},
			
			simple: {
				type: Boolean,
				default: true
			},
			
			accept: {
				type: String,
				default: 'image/*'
			},

			value: {
				type: [FormData, Array]
			},
			
			upload: {
				type: Function
			},
			
			preview: {
				type: Boolean,
				default: true
			}
		},
		
		/* created(){
			if(window.native && (!window.IDCardShootPageNationalEmblemImageData)){
				window.IDCardShootPageNationalEmblemImageData = base64 => {
					return base64
				}
			}
		}, */
		
		data(){
			return {
				fileList: '',
				src: '',
				show: false,
				temps: [],
				isInApp: !!window.native
			}
		},
		
		methods: {
			appClick(){
				/* if(window.native){
					window.native.apiOpenPhotoLibray('800', '600')
					return false
				} */
			},
			
			zoom(img){
				event.stopPropagation()
				const type = typeof img
				switch(type){
					case 'string': {
						this.$dialog()
						break
					};
					case 'object': {
						this.$dialog({
							transparent: true,
							component: () => import('../zoom/Index.vue'),
							props: {
								src: img.src,
								download: false
							}
						})
					}
				}
			},
			
			async changeHandler(){
				if(this.preview){
					this.getResources(true)
				}else{
					this.getResources(true)
					const {afterUpload} = this.$listeners
					if(this.preview){
						this.$emit('localHandler', this.temps) //调本地图片处理方法（还没有上传），一般用于处理显示本地缩略图
					}
					
					if(this.upload){
						const urls = await this.upload(this.setValue(), this.temps)
						this.temps.forEach(img => this.showImage(img))
						this.$emit('input', urls)
					}
				}
			},
			
			getResources(show){
				const arr = Array.from(event.target.files).map(file => new UploadEntity({file, show}))
				if(this.simple){
					this.temps.splice(0, 1, ...arr)
				}else{
					this.temps.push(...arr)
				}				
			},
			
			setValue(){
				const formData = new FormData()
				this.temps.forEach(({show, file}) => {
					if(show){
						formData.append('files', file)
					}
				})
				this.$emit('input', formData)
				return formData
			},
			
			showImage(img){
				img.status = 'loading'
			},
			
			remove(img){
				event.stopPropagation()
				this.$actionSheet({
					cancel: true,
					buttons: [
						{text: '确定移除此图片', handler: close => {
							img.show = false
							this.setValue()
							close()
						}}
					]
				})
			}
		}
	}
</script>

<style lang="scss" type="text/scss">
	@import '../../../../assets/styles/vars.scss';
	
	.upload-wrapper{
		//min-height: 160px;
		color: inherit;
		
		.box-border{
			position: relative;
			background: #CCC;
			margin: 0 8px;
			border-radius: 21px;
			
			.animation-circle{
				z-index: 4;
			}
			
			.icon-close{
				position: absolute;
				right: 0;
				top: 0;
				border-radius: 10px 0 10px 100px;
				background: $btn_danger_color;
				padding: 0 0 4px 4px;
				z-index: 7;
				box-shadow: 0 0 10px rgba(#000, 1);
			}
		}
		
		.photo{
			position: relative;
			background: transparent;
			border: dotted 4px #ccc;
			
			.photo-input{
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				opacity: 0;
			}
		}
		
		.upload-init{
			transition: all 1.2s;
			position: absolute;
			background: transparent;
			border-radius: 500px;
			border: solid 160px rgba(#000, 1);
			z-index: 3;
			
			&.upload-loading{
				border-width: 0;
			}
		}
		
		.upload-pic{
			position: absolute;
		}
	}
</style>
